export default __webpack_public_path__ + "static/media/clock-yellow.bf8055b7.svg";